import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons/faSpinner";
import { addLoadingIndicator, removeLoadingIndicator } from "@redux/actions/loading-indicators-actions";
import styles from "./loading-indicator.less";

type LoadingIndicatorProps = {
    title: string;
    message?: string;
};

export const LoadingIndicator = (props: LoadingIndicatorProps) => {
    const { title, message } = props;
    const dispatch = useDispatch();

    useEffect(() => {
        const uuid = uuidv4();
        dispatch(addLoadingIndicator(uuid));

        return () => {
            setTimeout(() => {
                // delay the execution of this function by 300 ms
                dispatch(removeLoadingIndicator(uuid));
            }, 300);
        }
    }, []);

    return (
        <div className={styles.loadingIndicator}>
            <div>
                <h1>{title}</h1>
                {message && (<p>{message}</p>)}
            </div>
            <FontAwesomeIcon icon={faSpinner} className={"fa-spin fa-3x fa-fw fa-pulse"} />
        </div>
    );
};